import { ArrowDownAZ, Funnel, SearchIcon, XIcon } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";
import { useMemo } from "react";

export enum EnumJobMatchesFilter {
    BOTH = 'both',
    PROFILE = 'profile',
    ASPIRATION = 'aspiration',
    FAVORITE = 'favorite',
    CLOSED = 'closed'
}

export enum EnumJobMatchesSortingFilter {
    MOST_RECENT = 'mostRecent',
    HIGHEST_MATCH = 'highestMatch',
    LONGEST_INACTIVITY = 'longestInactivity'
}

export const jobMatchesFilters = [
    {
        label: "All",
        value: EnumJobMatchesFilter.BOTH,
    },
    {
        label: "Profile Match",
        value: EnumJobMatchesFilter.PROFILE,
    },
    {
        label: "Aspiration Match",
        value: EnumJobMatchesFilter.ASPIRATION,
    },
    // {
    //     label: "Saved",
    //     value: EnumJobMatchesFilter.FAVORITE,
    // },
    // {
    //     label: "Closed",
    //     value: EnumJobMatchesFilter.CLOSED,
    // },
];

export const jobMatchesSortingFilters = [
    {
        label: "Most Recent Update",
        value: EnumJobMatchesSortingFilter.MOST_RECENT,
    },
    {
        label: "Highest % Match",
        value: EnumJobMatchesSortingFilter.HIGHEST_MATCH,
    },
    {
        label: "Longest Period of Inactivity",
        value: EnumJobMatchesSortingFilter.LONGEST_INACTIVITY,
    },
];

const FilterSection = ({
    activeFilter,
    setActiveFilter,
    activeSortingFilter,
    setActiveSortingFilter,
    favoriteFilter,
    setFavoriteFilter
}) => {
    const isClearFilterByEnabled = useMemo(() => activeFilter?.value !== EnumJobMatchesFilter.BOTH || favoriteFilter, [activeFilter, favoriteFilter])

    const isClearSortByEnabled = useMemo(() => activeSortingFilter?.value !== EnumJobMatchesSortingFilter.MOST_RECENT, [activeSortingFilter])

    return <>
        <DropdownMenu>
            <div className="relative mr-2.5">
                <DropdownMenuTrigger
                    className="flex items-center text-charcoal font-semibold text-xs border rounded-md h-9 gap-1 px-3 outline-none w-72"
                >
                    <ArrowDownAZ size={15} />
                    Sort By : <span className="text-light-black">{activeSortingFilter?.label}</span>
                </DropdownMenuTrigger>
                {
                    isClearSortByEnabled ?
                        <button
                            onClick={() => setActiveSortingFilter(jobMatchesSortingFilters[0])}
                            className="bg-red-500 rounded-full p-px absolute -top-2 -right-2 hover:scale-125">
                            <XIcon color="white" size={13} strokeWidth={2.5} />
                        </button>
                        : null
                }
            </div>
            <DropdownMenuContent className="bg-white" align="start">
                <div className="flex flex-col gap-2 px-2 py-3">
                    <span className="text-xs mb-1">Sort By</span>
                    {jobMatchesSortingFilters?.map((filter) => {
                        const isSelected = filter?.value === activeSortingFilter?.value
                        return (
                            <DropdownMenuItem
                                key={filter?.value}
                                className={`flex gap-3 text-xs outline-none font-medium hover:cursor-pointer hover:bg-gray-50`}
                                onSelect={() => setActiveSortingFilter(filter)}
                            >
                                <div className="flex w-4 h-4 rounded-full border border-primary">
                                    {
                                        isSelected ?
                                            <div className="w-2.5 h-2.5 bg-primary rounded-full m-auto" />
                                            :
                                            null
                                    }
                                </div>
                                {filter?.label}
                            </DropdownMenuItem>
                        );
                    })}
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
        <DropdownMenu>
            <div className="relative mr-2.5">
                <DropdownMenuTrigger
                    defaultValue={EnumJobMatchesFilter.BOTH}
                    className="flex items-center text-charcoal font-semibold text-xs border rounded-md h-9 gap-1 px-3 outline-none w-56"
                >
                    <Funnel size={15} />
                    Filter By : <span className="text-light-black">{activeFilter?.label}</span>
                </DropdownMenuTrigger>
                {
                    isClearFilterByEnabled ?
                        <button
                            onClick={() => {
                                setActiveFilter(jobMatchesFilters[0])
                                setFavoriteFilter(false)
                            }}
                            className="bg-red-500 rounded-full p-px absolute -top-2 -right-2 hover:scale-125">
                            <XIcon color="white" size={13} strokeWidth={2.5} />
                        </button>
                        : null
                }
            </div>
            <DropdownMenuContent className="bg-white" align="start">
                <div className="flex flex-col gap-2 px-2 pt-3">
                    <span className="text-xs mb-1">Filter By</span>
                    {jobMatchesFilters?.map((filter) => {
                        const isSelected = filter?.value === activeFilter?.value
                        return (
                            <DropdownMenuItem
                                key={filter?.value}
                                className={`flex gap-3 text-xs outline-none hover:cursor-pointer hover:bg-gray-50`}
                                onSelect={() => setActiveFilter(filter)}
                            >
                                <div className="flex w-4 h-4 rounded-full border border-primary">
                                    {
                                        isSelected ?
                                            <div className="w-2.5 h-2.5 bg-primary rounded-full m-auto" />
                                            :
                                            null
                                    }
                                </div>
                                {filter?.label}
                            </DropdownMenuItem>
                        );
                    })}
                    <div className="border-t border-gray-200" />
                    <DropdownMenuItem
                        className={`flex gap-3 text-xs outline-none hover:cursor-pointer rounded-md hover:bg-gray-50`}
                        onSelect={() => setFavoriteFilter((prev) => !prev)}
                    >
                        <div className="flex w-4 h-4 rounded-full border border-primary">
                            {
                                favoriteFilter ?
                                    <div className="w-2.5 h-2.5 bg-primary rounded-full m-auto" />
                                    :
                                    null
                            }
                        </div>
                        Show favorites
                    </DropdownMenuItem>
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
    </>
}

export default FilterSection